import React from 'react';
import { NavLink as rrNavLink } from 'react-router-dom';
import { NavLink } from 'reactstrap';

class Navigation extends React.Component {
    render(){
        return (
            <nav className="navbar report-nav pb-0 pt-1 px-0">
                <ul className="nav nav-tabs report-nav flex-column flex-md-row">
                    {
                        this.props.reportCategories.map((category) =>
                            <li className="nav-item ml-1 pt-1" key={category.id}>
                                <NavLink tag={rrNavLink} to={"/category/" + category.id}>{category.title}</NavLink>
                            </li>
                        )
                    }
                </ul>
            </nav>
        );
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/partials/Navigation.jsx